(function (app) {

    app.provider("iPipelineApi",
        [
            function () {
                this.$get = [
                    "complianceHubApiGateway", function (complianceHubApiGateway) {
                        var service = {};

                        service.initiateiPipelineSso = function (relayStateId) {          
                            return complianceHubApiGateway.post("/IpipelineSso/" + relayStateId);
                        };

                        return service;
                    }
                ];
            }
        ]);
})(window.app); //jshint ignore:line